import React from 'react';
import Egg from 'products/global/assets/img/notfound/egg.png';
import {
  ErrorContainer,
  Section,
  Content,
  Title,
  SubTitle,
  Image,
  Button
} from './styled';

const ErrorPage = () => {
  window.Intercom('trackEvent', 'page-error', { page: window.location.pathname });
  window.Intercom('showNewMessage', 'I’m experiencing some problems. Can you help me?');

  return (
    <ErrorContainer>
      <Section>
        <Content>
          <Title>Something went wrong</Title>
          <SubTitle>
            Sorry, you just ran into an error on our website.
            <br />
            We would appreciate it if you told our customer service team in the lower
            right corner what you were trying to do so we can fix it!
          </SubTitle>
          <Button onClick={() => (window.location = '/')}>Go to home page</Button>
        </Content>
        <Image>
          <img src={Egg} alt="Empty bird nest" />
        </Image>
      </Section>
    </ErrorContainer>
  );
};

export default ErrorPage;
